import { useRouterStateReturnUrl } from './useRouterStateReturnUrl';
import { useSearchParamsReturnUrl } from './useSearchParamsReturnUrl';

export const useReturnUrl = () => {
    const routerStateFlavour = useRouterStateReturnUrl();
    const searchParamFlavour = useSearchParamsReturnUrl();
    if (routerStateFlavour[0]) {
        return routerStateFlavour;
    }
    return searchParamFlavour;
};
